import { Injectable } from '@angular/core';
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import { environment } from '../../../environments/environment';
import { UserService } from '../../core/services';
import { User } from '../../core/models/user.model';
import { debounceTime, filter } from 'rxjs/operators';
import { AccountAttributesEnum } from '../enums';
import { Observable, of, Subscriber } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RumService {
  constructor(private readonly userService: UserService) {}

  initSession(dataDogSessionRecording?: boolean, accountName?: string): Observable<boolean> {
    const isDataDogAllowed: boolean = Boolean(environment.production && environment.isDatadogAllowed);

    if (isDataDogAllowed) {
      return new Observable<boolean>((subscriber: Subscriber<boolean>) => {
        datadogRum.init({
          ...environment.dataDog,
          env: environment.environmentIdentifier,
          version: environment.version,
          defaultPrivacyLevel: environment.dataDog.defaultPrivacyLevel as DefaultPrivacyLevel,
          allowedTracingUrls: ['https://api.circleback.com', 'https://api.salesintel.io']
        });

        datadogRum.onReady(() => {
          if (this.userService.hasAccess(AccountAttributesEnum.DATADOGSESSIONRECORDING) || dataDogSessionRecording) {
            datadogRum.startSessionReplayRecording();
          }
          if (dataDogSessionRecording) {
            datadogRum.setUser({
              accountName: accountName
            });
          } else {
            this.initUserObservation();
          }
          subscriber.next(true);
          subscriber.complete();
        });
      });
    }
    return of(true);
  }

  private initUserObservation() {
    this.userService.getUserData()
      .pipe(
        filter(Boolean),
        debounceTime(100),
      )
      .subscribe(({ id, email, account_id, account_name }: User) => {
        datadogRum.setUser({
          id: id.toString(),
          email,
          accountId: account_id,
          accountName: account_name
        });
      });
  }
}
